// extracted by mini-css-extract-plugin
export default {"bcMultipleComboboxWrapper":"bcMultipleComboboxWrapper_hR5uI","fromMobile":"fromMobile_iztIo"};